import ApiService from './api.service';

class InvitationService {
  async list() {
    try {
      const response = await ApiService.get('/invitation');
      console.log('Raw API response:', response);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/invitation/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/invitation/edit', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/invitation/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async show(id) {
    try {
      const response = await ApiService.get(`/invitation/show/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }


}

export default new InvitationService();
